export default __webpack_public_path__ + "static/media/register-bg.d2e27a47.jpg";